import React, { Component, Context, CSSProperties } from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { FirebaseError } from "firebase";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { IAppState, mapAppStateToProps } from "../../../redux/reducers/app";
import { IAppActionDispatches, mapAppDispatchToProps, IAppStoreProps } from "../../../redux/actions/app";
import NotificationsService from "../../../laco-common/services/notifications";
// import backArrow from "../../../assets/backArrow.svg";
import { withAuth, IAuthProps } from "../../../laco-common/auth/AuthContext";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import { DynamicForm } from "../../../forms/DynamicForm";
import { DynamicFormValidation, DynamicFormField } from "../../../laco-common/base/form-validation/dynamic";
import { FormField, ICustomValidatorResult, ErrorType } from "../../../laco-common/base/form-validation";
import Logo from "../../layout/Logo";
import { UIPageTitle } from "../../ui/UIPageTitle";
import { IUserProfileData } from "../../../laco-common/base/models/user";
import { UICMSContent } from "../../ui/UICMSContent";
import { getBaseProfileFields } from "./UpdateProfile";
import firewireIcon from "../../../assets/firewireicon.png";
import SitePagesPoller from "../../../services/SitePagesPoller";
import { ISitePage } from "../../../laco-common/base/models/page";
import { LOCAL_STORAGE_KEYS } from "../../../models/localStorage";
import "../layout/auth-page.scss";

type AuthPageMode = "login" | "join" | "forgot-password";

type AuthPageProps = {
	pageId: string;
	pageName: string;
};

type AuthFormState = {
	loading: boolean;
	mode: AuthPageMode;
	form: DynamicFormValidation;
	close: boolean;
};

// TODO: save email - forgot password
class AuthPage extends Component<RouteComponentProps & IAuthProps & IAppStoreProps & AuthPageProps, AuthFormState> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	private routeKey: string;
	private _historySub = null;
	private readonly loginFormFields = {
		email: {
			value: "",
			label: "Email",
			mandatory: true,
			valid: false,
			email: true,
			order: 1,
			autoComplete: "email",
			placeholder: "Enter your email",
		},
		password: {
			value: "",
			label: "Password",
			mandatory: true,
			valid: false,
			fieldType: "password" as any,
			order: 2,
			autoComplete: "password",
			placeholder: "Enter your password",
		}, // TODO: in registration process infoText: "Min 8 chars"
	};

	state = {
		loading: false,
		mode: null,
		form: null,
		close: false,
	};

	componentDidMount() {
		console.log("Login componentDidMount redirect from:", this.props.location.state);
		this._historySub = this.props.history.listen((location, action) => {
			this.init(location);
		});
		this.init();
	}

	componentWillUnmount() {
		this._historySub();
	}

	init(location?) {
		//const newRouteKey: string = this.props.location.key;
		//if (fromRouter && newRouteKey === this.routeKey) return;
		//this.routeKey = newRouteKey;
		const mode: AuthPageMode = (location || this.props.history.location)?.pathname.substr(1) as AuthPageMode;
		const form: DynamicFormValidation = this.getForm(mode);
		console.log("mode, form, props:", mode, form, this.props);
		console.log("AuthPage this props:", this.props);
		const page: ISitePage = this.props.pages.find((p) => p.id === mode);
		if (page) {
			this.props.setCurrentPage(
				// {
				// 	id: mode,
				// 	active: true,
				// 	created_at: null,
				// 	updated_at: null,
				// 	order: 1,
				// 	parentPage: "root",
				// },
				page,
				true,
				true
			);
		}
		// const title: string = this.getPageTitle(mode);

		this.setState({ mode, form });
	}

	getForm(mode: AuthPageMode): DynamicFormValidation {
		const { email, password } = this.loginFormFields;
		switch (mode) {
			case "login":
				return new DynamicFormValidation({ email, password });
				break;
			case "join":
				const formFields: {
					[key: string]: DynamicFormField;
				} = getBaseProfileFields(false);
				formFields.primary_email.mandatory = true;
				formFields.password.minLength = 6;
				formFields.mobile_number = {
					order: 9,
					label: "Mobile No.",
					autoComplete: "mobile",
					valid: true,
					mandatory: false,
					value: "",
					isPhoneNo: true,
					customValidator: (field: FormField): ICustomValidatorResult => {
						let errProps: Partial<ICustomValidatorResult> = {};
						if (field.value && field.value.length !== 10) {
							errProps = {
								errType: ErrorType.Invalid,
								msg: "",
							};
							field.valid = false;
						}
						return { field, ...errProps };
					},
				};

				return new DynamicFormValidation(formFields);
				break;
			case "forgot-password":
				return new DynamicFormValidation({ email });
				break;
		}
	}

	doesPathRequireAuth(path: string): boolean {
		const { pages } = SitePagesPoller.pagesPayload;
		const found = pages.find((p) => `/${p.path}` === path);
		return found?.requiresAuth;
	}

	redirect() {
		const localStorageRedirect: string = localStorage.getItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT);
		let redirectTo: string = localStorageRedirect
			? localStorageRedirect
			: this.props.location.state && (this.props.location.state as any).redirectedFrom
			? (this.props.location.state as any).redirectedFrom.pathname
			: "/";
		if (localStorageRedirect) {
			localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_REDIRECT, "");
		}
		if (this.doesPathRequireAuth(redirectTo)) {
			this.props.history.goBack();
		} else {
			this.props.history.push(redirectTo);
		}
	}

	getDesc(): string | React.ReactNode {
		switch (this.state.mode) {
			case "login":
				break;
			case "join":
				return (
					!!this.props.activePage.content && (
						<div className="mb-4" style={{ marginTop: "-15px" }}>
							<UICMSContent content={this.props.activePage.content} />
						</div>
					)
				);

			case "forgot-password":
				return (
					<p className="mb-4_5">
						Enter the email you used to create your account. You will receive an email with a link to reset
						your password.
					</p>
				);
		}
	}

	getBtnName(): string {
		switch (this.state.mode) {
			case "login":
				return "Log In";
			case "join":
				return "Join";
			case "forgot-password":
				return "Send Reset Link";
		}
	}

	getActionName(): string {
		switch (this.state.mode) {
			case "login":
				return "Logging in...";
			case "join":
				return "Joining...";
			case "forgot-password":
				return "Processing...";
		}
	}

	getTopLink(): React.ReactNode {
		switch (this.state.mode) {
			case "login":
				return (
					<div className="text-gray">
						Don't have an account? <NavLink to="/join">Join Now!</NavLink>
					</div>
				);
			case "join":
				return (
					<div className="text-gray">
						Already have an account? <NavLink to="/login">Login</NavLink>
					</div>
				);
			case "forgot-password":
				return (
					<div className="text-gray">
						<NavLink to="/login">
							<i className="im im-angle-left"></i> Back to Login
						</NavLink>
					</div>
				);
		}
	}

	getBottomLink(): React.ReactNode {
		switch (this.state.mode) {
			case "login":
				return (
					<NavLink className="gray-link" to={"/forgot-password"}>
						Forgot Your Password?
					</NavLink>
				);
			case "join":
				return (
					<NavLink className="gray-link" to={"/login"}>
						Already have an account? Login
					</NavLink>
				);
			case "forgot-password":
				return (
					<NavLink className="gray-link" to={"/login"}>
						Back to Login
					</NavLink>
				);
		}
	}

	async getAction(): Promise<any> {
		switch (this.state.mode) {
			case "login":
				return this.props.authContext
					.login(this.state.form.fields.email.value, this.state.form.fields.password.value)
					.then((userData: IUserProfileData) => {
						NotificationsService.success(`Hello ${userData.first_name}`, undefined, {
							autoHideDuration: 9999,
						});
						this.redirect();
					});
			case "join": {
				const registrationData = this.state.form.values;
				console.log("Join registrationData:", registrationData);
				return this.props.authContext
					.register(registrationData, "subscriber")
					.then((userData: IUserProfileData) => {
						NotificationsService.info(
							`Welcome ${userData.first_name}. ${this.props.activePage.texts["registration-subscriber-checkout-message"]}`,
							undefined,
							{
								autoHideDuration: 9999,
							}
						);
						this.props.history.push("/checkout#!/~/cart");
					})
					.catch((err: FirebaseError) => {
						console.error(err);
						NotificationsService.error(err.message);
					});
			}
			case "forgot-password":
				return this.props.authContext
					.getAuthApp()
					.auth()
					.sendPasswordResetEmail(this.state.form.fields.email.value)
					.then((res: any) => {
						NotificationsService.success(
							"Please check for your reset email from Firewire App and follow the instructions.",
							undefined,
							{ autoHideDuration: 9999 }
						);
						this.props.history.push("/login");
					});
		}
	}

	async handleSubmit(): Promise<any> {
		this.setState({ loading: true });
		return this.getAction()
			.catch((err: firebase.FirebaseError) => {
				NotificationsService.error(err.message);
				console.error(err);
			})
			.finally(() => {
				this.setState({ loading: false });
			});
	}

	render() {
		console.log("AuthPage render() form:", this.state.form);
		const activePage = this.props.activePage;
		console.log("Authpage activePage:", activePage);
		const bgImgStylesOverride: CSSProperties = {};
		if (this.props.activePage && this.props.activePage.headerImage1) {
			bgImgStylesOverride.backgroundImage = `url("${this.props.activePage.headerImage1}")`;
		}
		return (
			<div className="auth-page d-flex justify-content-end">
				<UIPageTitle pageTitle={activePage?.title} />
				<div
					className={clsx("main-img animated1 fadeIn fast", this.state.loading && "loading")}
					style={bgImgStylesOverride}
				></div>
				<Logo
					white={activePage?.invertColors && this.context.settings.isDesktopRes}
					className="position-absolute auth-logo-container"
				/>
				<div className={clsx("auth-form animated slideInRight1 fadeIn", this.state.close && "fadeOut fast-2")}>
					{/* key={this.state.mode} */}
					<div className="d-flex justify-content-between">
						{this.getTopLink()}
						<span className="auth-page-close-icon">
							<IconButton
								edge="start"
								aria-label="Close"
								// className="ui-modal-close-icon"
								onClick={(e) => {
									e.preventDefault();
									this.setState({ close: true });
									setTimeout(() => {
										this.redirect();
									}, 150);
								}}
							>
								<CloseIcon />
							</IconButton>
						</span>
					</div>

					{!!this.state.form && (
						<DynamicForm
							key={this.state.mode}
							skipAutoFocus
							title={
								<>
									{activePage?.title}
									{this.state.mode === "login" && (
										<span className="text-md ml-2 text-gray ">
											<img
												src={firewireIcon}
												width="18"
												style={{ borderRadius: "3px", marginRight: "5px", marginTop: "-3px" }}
											/>
											Firewire user? Login below
										</span>
									)}
								</>
							}
							description={this.getDesc()}
							form={this.state.form}
							submitBtn={this.getBtnName()}
							submitBtnClassName="w-100"
							actionName={this.getActionName()}
							onSubmit={this.handleSubmit.bind(this)}
						/>
					)}
					<div className="text-right mt-4">{this.getBottomLink()}</div>
				</div>
			</div>
		);
	}
}

export default connect<IAppState, IAppActionDispatches, AuthPageProps>(
	mapAppStateToProps,
	mapAppDispatchToProps
)(withAuth(AuthPage));
